// extracted by mini-css-extract-plugin
export var content = "newsletter-gist-picks-module--content--7bab2";
export var image = "newsletter-gist-picks-module--image--b9379";
export var imageWrap = "newsletter-gist-picks-module--imageWrap--11f4f";
export var intro = "newsletter-gist-picks-module--intro--8509f";
export var intro__lifestyle = "newsletter-gist-picks-module--intro__lifestyle--5cbd6";
export var number = "newsletter-gist-picks-module--number--70898";
export var number__light = "newsletter-gist-picks-module--number__light--cff69";
export var pick = "newsletter-gist-picks-module--pick--34c3d";
export var spin = "newsletter-gist-picks-module--spin--9a8c7";
export var wrapper = "newsletter-gist-picks-module--wrapper--d7dca";
export var wrapper__black = "newsletter-gist-picks-module--wrapper__black--10600";
export var wrapper__bloodorange = "newsletter-gist-picks-module--wrapper__bloodorange--86b97";
export var wrapper__chartruse = "newsletter-gist-picks-module--wrapper__chartruse--8b401";
export var wrapper__cobalt = "newsletter-gist-picks-module--wrapper__cobalt--9e99b";
export var wrapper__emerald = "newsletter-gist-picks-module--wrapper__emerald--575dd";
export var wrapper__paper = "newsletter-gist-picks-module--wrapper__paper--2b9d7";
export var wrapper__pink = "newsletter-gist-picks-module--wrapper__pink--e7122";
export var wrapper__sky = "newsletter-gist-picks-module--wrapper__sky--a26df";
export var wrapper__white = "newsletter-gist-picks-module--wrapper__white--9eb8b";